'use client';

import React from "react";
import Dashboard from "../pages/dashboard";

export default function Home(): React.ReactElement {
  return (
    <div className="flex w-full flex-col">
      <Dashboard />
    </div>
  );
}